import { FaRegHandshake } from 'react-icons/fa';
import { MdOutlineDiscount } from 'react-icons/md';
import { HiOutlineUserGroup } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';

export const Advantages = () => {
  const { t } = useTranslation();
  return (
    <section className="my-5">
      <div className="container">
        <div className="row d-flex align-items-stretch">
          <div className="col-md-6 col-lg-4 mb-4 advantages-wrapper ">
            <div className="advantage text-center align-items-center d-flex flex-column gap-2">
              <div className="first p-3 rounded-circle">
                <MdOutlineDiscount className="display-4" />
              </div>
              <p className="text-center fs-5 fw-bold">{t('Post your jobs free')}</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 mb-4 advantages-wrapper">
            <div className="advantage text-center align-items-center d-flex flex-column gap-2">
              <div className="second p-3 rounded-circle">
                <FaRegHandshake className="display-4" />
              </div>

              <p className="text-center fs-5 fw-bold">{t('The workers we offer are reliable')}</p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 mb-4 advantages-wrapper">
            <div className="advantage text-center align-items-center d-flex flex-column gap-2">
              <div className="third p-3 rounded-circle">
                <HiOutlineUserGroup className="display-4" />
              </div>
              <p className="text-center fs-5 fw-bold">{t('Coincides workers with reality')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
